import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import LifetimeReviewVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/LifetimeReviewVolumeByStarRatingChart';
import ProductCatalogCountReviewRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ProductCatalogCountReviewRatingChart';
import ReviewDonutAndTopEntityChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ReviewDonutAndTopEntityChart';
import ReviewDoubleDropdownTopEntityChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ReviewDoubleDropdownTopEntityChart';
import ReviewProductCatalogCountByCumulativeVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/ReviewProductCatalogCountByCumulativeVolumeChart';
import WeeklyReviewProductChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/WeeklyReveiwProductChart';
import WeeklyReviewVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/WeeklyReviewVolumeByStarRatingChart';
import WeeklyReviewVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewAnalysis/WeeklyReviewVolumeChart';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { EntityNoDataPlaceHolder } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity, useSubcategoryEntity } from 'src/utils/Hooks/reduxSelectors';

const ReviewAnalysisPage = () => {
  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: ['childLifetimeRatingVolume']
  });

  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            {/* Review Quality Score */}
            <ReviewDonutAndTopEntityChart />
            {/* Weekly Review Volume */}
            {isProductEntity ? <WeeklyReviewProductChart /> : <WeeklyReviewVolumeChart />}
            {/* Weekly Review Volume by Star Rating */}
            <WeeklyReviewVolumeByStarRatingChart />
            {/* Cumulative Review Volume by Star Rating */}
            <LifetimeReviewVolumeByStarRatingChart />
            {/* Product Catalog Count by Cumulative Review Volume Tier */}
            {!isProductEntity && <ReviewProductCatalogCountByCumulativeVolumeChart />}
            {/* Product Catalog Count by Cumulative Review Rating Tier */}
            {!isProductEntity && <ProductCatalogCountReviewRatingChart />}
            {/* Cumulative Review Volume by Category */}
            {!isCategoryEntity && !isSubcategoryEntity && !isProductEntity && (
              <ReviewDoubleDropdownTopEntityChart groupByField="categoryId" />
            )}
            {/* Cumulative Review Volume by Subcategory */}
            {!isSubcategoryEntity && !isProductEntity && (
              <ReviewDoubleDropdownTopEntityChart groupByField="subCategoryId" />
            )}
            {/* Product/Review card grid */}
            <ReviewSummaryProductGrid metric="reviews" tableComponent="review" />
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewAnalysisPage;
